/* --- tabbed-drawer --- */
if (!customElements.get('tabbed-drawer')) {
  customElements.define(
    'tabbed-drawer',
    class TabbedDrawer extends HTMLElement {
      connectedCallback() {
        const modalSelector = this.dataset.modal; // e.g. "#ProductPropertiesPanel"
        const modal = document.querySelector(modalSelector);

        if (!modal) return;

        this.querySelectorAll('.tab-list__button').forEach(button => {
          button.addEventListener('click', () => {
            const index = button.dataset.index;

            // Open the modal
            modal.setAttribute('open', 'true');
            document.body.classList.add('overlay-active', 'overflow-hidden');

            // Tell modal which tab index should be active
            modal.dispatchEvent(
              new CustomEvent('tabbed-drawer:open', {
                detail: { index },
                bubbles: true,
              })
            );

            // Enable click-to-close behavior
            modal.addBodyClickListener();
          });
        });
      }
    }
  );
}

/* --- modal-panel --- */
if (!customElements.get('modal-panel')) {
  customElements.define(
    'modal-panel',
    class ModalPanel extends HTMLElement {
      connectedCallback() {
        this.closeBtn = this.querySelector('.product-popup-modal__toggle');

        if (this.closeBtn) {
          this.closeBtn.addEventListener('click', () => this.close());
        }

        // Listen for tab activation events
        this.addEventListener('tabbed-drawer:open', (e) => {
          const { index } = e.detail;
          this.showTab(index);
        });

        // Also wire up modal’s own tab buttons
        this.querySelectorAll('.tab-panel-button').forEach(button => {
          button.addEventListener('click', () => {
            const index = button.dataset.index;
            this.showTab(index);
          });
        });

        // Add after for tab button overflow
        const buttonsCont = this.querySelector('.tab-panel__buttons__inner');
        if (buttonsCont.scrollWidth > buttonsCont.clientWidth) {
          buttonsCont.classList.add('show-after');
        }

        buttonsCont.addEventListener('scroll', event => {
          if (event.currentTarget.scrollLeft + event.currentTarget.clientWidth < event.currentTarget.scrollWidth) {
            event.currentTarget.classList.add('show-after');
          } else {
            event.currentTarget.classList.remove('show-after');
          }

          const atStart = event.currentTarget.scrollLeft === 0;
          event.currentTarget.toggleAttribute('at-start', atStart);

          const atEnd = event.currentTarget.scrollLeft + event.currentTarget.clientWidth >= event.currentTarget.scrollWidth;
          event.currentTarget.toggleAttribute('at-end', atEnd);
        });
        // at-start
        // at-end


        // Add scroll listener for tab button overflow
        this.querySelector('.tab-panel__buttons').addEventListener('scroll', (event) => {
          // if (event.currentTarget.scrollLeft !== 0) {
          //   event.currentTarget.classList.remove('show-after');
          // } else {
          //   event.currentTarget.classList.add('show-after');
          // }

          if (event.currentTarget.scrollLeft + event.currentTarget.clientWidth < event.currentTarget.scrollWidth) {
            event.currentTarget.classList.add('show-after');
          } else {
            event.currentTarget.classList.remove('show-after');
          }


        });
      }

      addBodyClickListener() {
        // Ensure we don't double-bind
        if (this.onBodyClickEvent) {
          document.body.removeEventListener('click', this.onBodyClickEvent);
        }

        this.onBodyClickEvent = (e) => {
          const clickedOverlay = e.target.classList.contains('modal-overlay');
          const modalIsOpen = this.hasAttribute('open');
          if (modalIsOpen && clickedOverlay) {
            this.close();
          }
        };

        document.body.addEventListener('click', this.onBodyClickEvent);
      }

      showTab(index) {
        const tabs = this.querySelectorAll('.tab-panel-button');
        const panels = this.querySelectorAll('.tab-panel-content');

        tabs.forEach(btn => {
          btn.classList.toggle('active', btn.dataset.index === index);
          if (btn.dataset.index === index) {
            btn.scrollIntoView();
          }
        });
        panels.forEach(panel => {
          panel.classList.toggle('active', panel.dataset.index === index);
        });
      }

      close() {
        this.removeAttribute('open');
        document.body.classList.remove('overlay-active', 'overflow-hidden');
        document.body.removeEventListener('click', this.onBodyClickEvent);
      }
    }
  );
}
